import { formatScore } from './reputationView';

/**
 * TRIL-403: Compute the effective displayed score (earned + vouch boost, capped at 100).
 * Derives vouchedShown from the two rounded values so "earned + vouched = headline" is
 * always exact and the 100-cap is handled correctly.
 */
export function describeEffectiveScore(
  overallScore: number,
  vouchBoost: number,
): {
  earnedShown: number;
  effectiveShown: number;
  effectiveRaw: number;
  vouchedShown: number;
  hasBoost: boolean;
} {
  // Unrounded effective — feed this to the gauge so its arc keeps sub-integer
  // precision (rounding is display-only). With no boost this equals overallScore,
  // so a flag-off gauge is byte-identical to before TRIL-403.
  const effectiveRaw = Math.min(100, overallScore + (vouchBoost || 0));
  const earnedShown = formatScore(overallScore);
  const effectiveShown = formatScore(effectiveRaw);
  const vouchedShown = effectiveShown - earnedShown;
  return {
    earnedShown,
    effectiveShown,
    effectiveRaw,
    vouchedShown,
    hasBoost: vouchedShown > 0,
  };
}
